import { useAuth } from "@src/features/tenants";
import { Redirect } from "expo-router";
import { View } from "react-native";
import { BackgroundGradient } from "@src/components/BackgroundGradient";

export default function Index() {
  const { isAuthenticated, isInitialized } = useAuth();

  if (isAuthenticated && isInitialized) {
    return <Redirect href="/overview" />;
  }

  return (
    <BackgroundGradient>
      <View style={{ flex: 1, backgroundColor: "transparent" }} />
    </BackgroundGradient>
  );
}
